module.exports = __webpack_public_path__ + "static/media/trim-warez-o.12d0948a.png";